function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("circle", {
  opacity: 0.1,
  cx: 18,
  cy: 18,
  r: 18,
  fill: "#52AA55"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M17.4694 23.2262L17.4697 23.2265L18 23.7568L18.5303 23.2265L18.5306 23.2262L22.816 18.9408C23.1089 18.6479 23.1089 18.173 22.816 17.8801C22.5232 17.5872 22.0483 17.5872 21.7554 17.8801L18.75 20.8855V10.2676C18.75 9.85336 18.4142 9.51758 18 9.51758C17.5858 9.51758 17.25 9.85336 17.25 10.2676V20.8855L14.2446 17.8801C13.9517 17.5872 13.4768 17.5872 13.184 17.8801C12.8911 18.173 12.8911 18.6479 13.184 18.9408L17.4694 23.2262ZM12 24.089C11.5858 24.089 11.25 24.4248 11.25 24.839C11.25 25.2532 11.5858 25.589 12 25.589H24C24.4142 25.589 24.75 25.2532 24.75 24.839C24.75 24.4248 24.4142 24.089 24 24.089H12Z",
  fill: "#52AA55"
});

var SvgRecTrx = function SvgRecTrx(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgRecTrx, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/rec_trx.60abf836.svg";
export { ForwardRef as ReactComponent };